var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"400","color":"error"}},[_c('v-card-title',{staticClass:"text-h1 justify-center"},[_vm._v("404")]),_c('v-card-title',{staticClass:"text-h3 justify-center"},[_vm._v("Page not found")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }